import { createSlice, PayloadAction, createAction } from "@reduxjs/toolkit";
import { PatientInfo, Appointment } from "../../types";

// Definizione dello stato utente
export interface UserState {
  isLoggedIn: boolean;
  token: string;
  codiceFiscale: string;
  patientInfo: PatientInfo | null;
  rememberMe: boolean;
  appointment: Appointment | null;
  email?: string;
  lastLogin?: Date | string;
  emailConfirmed?: boolean;
}

const initialState: UserState = {
  isLoggedIn: false,
  token: "",
  codiceFiscale: "",
  patientInfo: null,
  rememberMe: false,
  appointment: null,
};

// Action per impostare patientInfo
export const setPatientInfo = createAction<PatientInfo>("user/setPatientInfo");
// Action per impostare un appuntamento
export const setAppointment = createAction<Appointment>("user/setAppointment");

// Reducer aggiornato
const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setLoggedIn(state, action: PayloadAction<boolean>) {
      state.isLoggedIn = action.payload;
      // Se l'utente si è loggato, segna come verificato e aggiorna lastLogin
      if (action.payload) {
        state.emailConfirmed = true;
        state.lastLogin = new Date().toISOString();
      }
    },
    setCodiceFiscale(state, action: PayloadAction<string>) {
      state.codiceFiscale = action.payload;
    },
    setToken(state, action: PayloadAction<string>) {
      state.token = action.payload;
    },
    setRememberMe(state, action: PayloadAction<boolean>) {
      state.rememberMe = action.payload;
    },
    setEmail(state, action: PayloadAction<string>) {
      state.email = action.payload;
    },
    setLastLogin(state, action: PayloadAction<string>) {
      state.lastLogin = action.payload;
    },
    setEmailConfirmed(state, action: PayloadAction<boolean>) {
      state.emailConfirmed = action.payload;
    },
    resetUser(state) {
      return initialState;
    },
  },
  extraReducers: builder => {
    builder.addCase(setPatientInfo, (state, action) => {
      state.patientInfo = action.payload;
    });
    builder.addCase(setAppointment, (state, action) => {
      state.appointment = action.payload;
    });
  },
});

export const { setLoggedIn, setCodiceFiscale, setToken, setRememberMe, setEmail, setLastLogin, setEmailConfirmed, resetUser } = userSlice.actions;
export default userSlice.reducer;
